<template>
  <va-edit-layout>
    <point-form :id="id" :title="title" :item="item"></point-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
